import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import AuthDialog from "@/components/AuthDialog";

const AuthDialogContext = createContext(null);

export function AuthDialogProvider({ children }) {
  const [open, setOpen] = useState(false);
  const cbRef = useRef(null);

  const openAuth = useCallback((onSuccess) => {
    cbRef.current = onSuccess || null;
    setOpen(true);
  }, []);

  return (
    <AuthDialogContext.Provider value={{ openAuth }}>
      {children}
      <AuthDialog
        open={open}
        onOpenChange={setOpen}
        onSuccess={() => { cbRef.current?.(); cbRef.current = null; }}
      />
    </AuthDialogContext.Provider>
  );
}

export function useAuthDialog() {
  return useContext(AuthDialogContext);
}
